// extracted by mini-css-extract-plugin
export default {"brass-background":"Background_brass-background__kscwU"};